@file:OptIn(InternalResourceApi::class)

package showcaseapp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.RegionQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/showcaseapp.composeapp.generated.resources/"

@delegate:ResourceContentHash(2_075_870_434)
internal val Res.string.display_style_square: StringResource by lazy {
      StringResource("string:display_style_square", "display_style_square", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12414, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13974, 52),
      ))
    }

@delegate:ResourceContentHash(1_150_138_626)
internal val Res.string.display_style_waterfall: StringResource by lazy {
      StringResource("string:display_style_waterfall", "display_style_waterfall", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12463, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14027, 43),
      ))
    }

@delegate:ResourceContentHash(-118_230_293)
internal val Res.string.donate: StringResource by lazy {
      StringResource("string:donate", "donate", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12507, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14071, 22),
      ))
    }

@delegate:ResourceContentHash(-1_412_638_533)
internal val Res.string.donation_open_failed: StringResource by lazy {
      StringResource("string:donation_open_failed", "donation_open_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/app_sharing.commonMain.cvr", 114, 80),
        ResourceItem(setOf(), "${MD}values/app_sharing.commonMain.cvr", 106, 96),
      ))
    }

@delegate:ResourceContentHash(1_200_598_513)
internal val Res.string.donation_qr_description: StringResource by lazy {
      StringResource("string:donation_qr_description", "donation_qr_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/app_sharing.commonMain.cvr", 195, 71),
        ResourceItem(setOf(), "${MD}values/app_sharing.commonMain.cvr", 203, 83),
      ))
    }

@delegate:ResourceContentHash(1_766_093_455)
internal val Res.string.donation_scan_hint: StringResource by lazy {
      StringResource("string:donation_scan_hint", "donation_scan_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/app_sharing.commonMain.cvr", 267, 102),
        ResourceItem(setOf(), "${MD}values/app_sharing.commonMain.cvr", 287, 106),
      ))
    }

@delegate:ResourceContentHash(1_042_850_924)
internal val Res.string.downloading_update: StringResource by lazy {
      StringResource("string:downloading_update", "downloading_update", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12530, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14094, 50),
      ))
    }

@delegate:ResourceContentHash(-1_409_917_206)
internal val Res.string.dream_description: StringResource by lazy {
      StringResource("string:dream_description", "dream_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14145, 37),
      ))
    }

@delegate:ResourceContentHash(-1_409_917_206)
internal val Res.string.dream_label: StringResource by lazy {
      StringResource("string:dream_label", "dream_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14183, 31),
      ))
    }

@delegate:ResourceContentHash(513_376_224)
internal val Res.string.duo_fold_effect: StringResource by lazy {
      StringResource("string:duo_fold_effect", "duo_fold_effect", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12581, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14215, 35),
      ))
    }

@delegate:ResourceContentHash(1_490_758_776)
internal val Res.string.duo_fold_retreat: StringResource by lazy {
      StringResource("string:duo_fold_retreat", "duo_fold_retreat", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12617, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14251, 60),
      ))
    }

@delegate:ResourceContentHash(1_855_206_286)
internal val Res.string.edit: StringResource by lazy {
      StringResource("string:edit", "edit", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12666, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14312, 20),
      ))
    }

@delegate:ResourceContentHash(-957_383_799)
internal val Res.string.email: StringResource by lazy {
      StringResource("string:email", "email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14333, 21),
      ))
    }

@delegate:ResourceContentHash(97_270_837)
internal val Res.string.empty_content: StringResource by lazy {
      StringResource("string:empty_content", "empty_content", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12687, 33),
      ))
    }

@delegate:ResourceContentHash(492_798_123)
internal val Res.string.enable_ai_image_summary: StringResource by lazy {
      StringResource("string:enable_ai_image_summary", "enable_ai_image_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12721, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14355, 63),
      ))
    }

@delegate:ResourceContentHash(-933_658_905)
internal val Res.string.error: StringResource by lazy {
      StringResource("string:error", "error", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12785, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14419, 21),
      ))
    }

@delegate:ResourceContentHash(-941_596_297)
internal val Res.string.fading: StringResource by lazy {
      StringResource("string:fading", "fading", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12807, 22),
      ))
    }

@delegate:ResourceContentHash(1_301_844_760)
internal val Res.string.fast: StringResource by lazy {
      StringResource("string:fast", "fast", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12830, 16),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14441, 20),
      ))
    }

@delegate:ResourceContentHash(-445_027_529)
internal val Res.string.featured_collections_photos: StringResource by lazy {
      StringResource("string:featured_collections_photos", "featured_collections_photos", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12847, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14462, 63),
      ))
    }

@delegate:ResourceContentHash(1_767_871_333)
internal val Res.string.feedback: StringResource by lazy {
      StringResource("string:feedback", "feedback", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12899, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14526, 28),
      ))
    }

@delegate:ResourceContentHash(1_383_579_636)
internal val Res.string.flip_demo_back_to_front: StringResource by lazy {
      StringResource("string:flip_demo_back_to_front", "flip_demo_back_to_front", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12924, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14555, 51),
      ))
    }

@delegate:ResourceContentHash(-429_479_883)
internal val Res.string.flip_demo_front_to_back: StringResource by lazy {
      StringResource("string:flip_demo_front_to_back", "flip_demo_front_to_back", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12972, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14607, 47),
      ))
    }

@delegate:ResourceContentHash(480_600_898)
internal val Res.string.flip_demo_horizontal_title: StringResource by lazy {
      StringResource("string:flip_demo_horizontal_title", "flip_demo_horizontal_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 13020, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14655, 86),
      ))
    }

@delegate:ResourceContentHash(-628_200_135)
internal val Res.string.flip_demo_vertical_title: StringResource by lazy {
      StringResource("string:flip_demo_vertical_title", "flip_demo_vertical_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 13091, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14742, 84),
      ))
    }

@delegate:ResourceContentHash(1_353_076_975)
internal val Res.string.flip_effect: StringResource by lazy {
      StringResource("string:flip_effect", "flip_effect", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 13160, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14827, 27),
      ))
    }

@delegate:ResourceContentHash(705_391_880)
internal val Res.string.focus_scale: StringResource by lazy {
      StringResource("string:focus_scale", "focus_scale", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 13188, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14855, 39),
      ))
    }

@delegate:ResourceContentHash(1_637_708_922)
internal val Res.string.follow_system: StringResource by lazy {
      StringResource("string:follow_system", "follow_system", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 13232, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14895, 41),
      ))
    }

@delegate:ResourceContentHash(-680_838_199)
internal val Res.string.forward: StringResource by lazy {
      StringResource("string:forward", "forward", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 13270, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14937, 27),
      ))
    }

@delegate:ResourceContentHash(1_097_111_633)
internal val Res.string.frame_style: StringResource by lazy {
      StringResource("string:frame_style", "frame_style", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 13294, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14965, 35),
      ))
    }

@delegate:ResourceContentHash(-1_732_541_004)
internal val Res.string.frame_wall_fix_size: StringResource by lazy {
      StringResource("string:frame_wall_fix_size", "frame_wall_fix_size", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 13330, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15001, 39),
      ))
    }

@delegate:ResourceContentHash(1_273_137_730)
internal val Res.string.frame_wall_random_size: StringResource by lazy {
      StringResource("string:frame_wall_random_size", "frame_wall_random_size", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 13374, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15041, 46),
      ))
    }

@delegate:ResourceContentHash(-1_248_354_279)
internal val Res.string.gallery_add_photos: StringResource by lazy {
      StringResource("string:gallery_add_photos", "gallery_add_photos", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 13421, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15088, 42),
      ))
    }

@delegate:ResourceContentHash(-774_833_351)
internal val Res.string.gallery_limited_selection_hint: StringResource by lazy {
      StringResource("string:gallery_limited_selection_hint", "gallery_limited_selection_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 13464, 182),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15131, 158),
      ))
    }

@delegate:ResourceContentHash(944_938_587)
internal val Res.string.gallery_no_new_photos: StringResource by lazy {
      StringResource("string:gallery_no_new_photos", "gallery_no_new_photos", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 13647, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15290, 57),
      ))
    }

@delegate:ResourceContentHash(-298_433_088)
internal val Res.string.gallery_no_photos: StringResource by lazy {
      StringResource("string:gallery_no_photos", "gallery_no_photos", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 13709, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15348, 45),
      ))
    }

@delegate:ResourceContentHash(-560_527_638)
internal val Res.string.gallery_remove_selected_confirm: StringResource by lazy {
      StringResource("string:gallery_remove_selected_confirm", "gallery_remove_selected_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 13751, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15394, 195),
      ))
    }

@delegate:ResourceContentHash(1_164_227_392)
internal val Res.string.gallery_select_more_photos: StringResource by lazy {
      StringResource("string:gallery_select_more_photos", "gallery_select_more_photos", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 13899, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15590, 58),
      ))
    }

@delegate:ResourceContentHash(-374_319_937)
internal val Res.string.gallery_selected_count: StringResource by lazy {
      StringResource("string:gallery_selected_count", "gallery_selected_count", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 13958, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15649, 58),
      ))
    }

@delegate:ResourceContentHash(-1_735_076_448)
internal val Res.string.gallery_selected_photos: StringResource by lazy {
      StringResource("string:gallery_selected_photos", "gallery_selected_photos", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 14013, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15708, 51),
      ))
    }

@delegate:ResourceContentHash(354_060_628)
internal val Res.string.gallery_selection_access_required: StringResource by lazy {
      StringResource("string:gallery_selection_access_required", "gallery_selection_access_required", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 14065, 217),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15760, 225),
      ))
    }

@delegate:ResourceContentHash(-985_994_501)
internal val Res.string.gallery_source_name: StringResource by lazy {
      StringResource("string:gallery_source_name", "gallery_source_name", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 14283, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15986, 55),
      ))
    }

@delegate:ResourceContentHash(-1_409_335_562)
internal val Res.string.gallery_source_not_found: StringResource by lazy {
      StringResource("string:gallery_source_not_found", "gallery_source_not_found", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 14331, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16042, 64),
      ))
    }

@delegate:ResourceContentHash(384_003_373)
internal val Res.string.gallery_updated: StringResource by lazy {
      StringResource("string:gallery_updated", "gallery_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 14388, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16107, 43),
      ))
    }

@delegate:ResourceContentHash(1_248_390_972)
internal val Res.string.get_token: StringResource by lazy {
      StringResource("string:get_token", "get_token", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 14432, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16151, 29),
      ))
    }

@delegate:ResourceContentHash(-1_578_902_528)
internal val Res.string.gitee_access_token_tips_title: StringResource by lazy {
      StringResource("string:gitee_access_token_tips_title", "gitee_access_token_tips_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 14466, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16181, 69),
      ))
    }

@delegate:ResourceContentHash(-400_255_581)
internal val Res.string.gitee_acess_token_tips_1: StringResource by lazy {
      StringResource("string:gitee_acess_token_tips_1", "gitee_acess_token_tips_1", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 14536, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16251, 172),
      ))
    }

@delegate:ResourceContentHash(-2_110_369_505)
internal val Res.string.gitee_acess_token_tips_2: StringResource by lazy {
      StringResource("string:gitee_acess_token_tips_2", "gitee_acess_token_tips_2", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 14677, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16424, 112),
      ))
    }

@delegate:ResourceContentHash(2_027_007_082)
internal val Res.string.gitee_acess_token_tips_3: StringResource by lazy {
      StringResource("string:gitee_acess_token_tips_3", "gitee_acess_token_tips_3", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 14790, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16537, 136),
      ))
    }

@delegate:ResourceContentHash(1_064_938_620)
internal val Res.string.gitee_acess_token_tips_4: StringResource by lazy {
      StringResource("string:gitee_acess_token_tips_4", "gitee_acess_token_tips_4", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 14907, 188),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16674, 204),
      ))
    }

@delegate:ResourceContentHash(-377_671_609)
internal val Res.string.gitee_acess_token_tips_5: StringResource by lazy {
      StringResource("string:gitee_acess_token_tips_5", "gitee_acess_token_tips_5", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 15096, 244),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16879, 152),
      ))
    }

@delegate:ResourceContentHash(-19_451_830)
internal val Res.string.github_access_token_tips_1: StringResource by lazy {
      StringResource("string:github_access_token_tips_1", "github_access_token_tips_1", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 15341, 318),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17032, 382),
      ))
    }

@delegate:ResourceContentHash(1_904_662_597)
internal val Res.string.github_access_token_tips_2: StringResource by lazy {
      StringResource("string:github_access_token_tips_2", "github_access_token_tips_2", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 15660, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17415, 126),
      ))
    }

@delegate:ResourceContentHash(-1_539_108_270)
internal val Res.string.github_access_token_tips_3: StringResource by lazy {
      StringResource("string:github_access_token_tips_3", "github_access_token_tips_3", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 15771, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17542, 138),
      ))
    }

@delegate:ResourceContentHash(-1_000_616_331)
internal val Res.string.github_access_token_tips_4: StringResource by lazy {
      StringResource("string:github_access_token_tips_4", "github_access_token_tips_4", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 15906, 226),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17681, 226),
      ))
    }

@delegate:ResourceContentHash(-1_797_714_527)
internal val Res.string.github_access_token_tips_5: StringResource by lazy {
      StringResource("string:github_access_token_tips_5", "github_access_token_tips_5", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 16133, 186),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17908, 154),
      ))
    }

@delegate:ResourceContentHash(-1_366_592_268)
internal val Res.string.github_access_token_tips_title: StringResource by lazy {
      StringResource("string:github_access_token_tips_title", "github_access_token_tips_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 16320, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18063, 70),
      ))
    }

@delegate:ResourceContentHash(-934_214_871)
internal val Res.string.have_no_permission: StringResource by lazy {
      StringResource("string:have_no_permission", "have_no_permission", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 16395, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18134, 50),
      ))
    }

@delegate:ResourceContentHash(-425_211_021)
internal val Res.string.help: StringResource by lazy {
      StringResource("string:help", "help", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 16442, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18185, 20),
      ))
    }

@delegate:ResourceContentHash(315_353_558)
internal val Res.string.hide_password: StringResource by lazy {
      StringResource("string:hide_password", "hide_password", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 16463, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18206, 41),
      ))
    }

@delegate:ResourceContentHash(-1_045_627_322)
internal val Res.string.home: StringResource by lazy {
      StringResource("string:home", "home", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18248, 20),
      ))
    }

@delegate:ResourceContentHash(2_117_273_285)
internal val Res.string.host: StringResource by lazy {
      StringResource("string:host", "host", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 16545, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18313, 20),
      ))
    }

@delegate:ResourceContentHash(-1_997_005_683)
internal val Res.string.host_is_invalid: StringResource by lazy {
      StringResource("string:host_is_invalid", "host_is_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 16501, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18269, 43),
      ))
    }

@delegate:ResourceContentHash(25_423_963)
internal val Res.string.interval: StringResource by lazy {
      StringResource("string:interval", "interval", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 16613, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18385, 28),
      ))
    }

@delegate:ResourceContentHash(-1_460_616_733)
internal val Res.string.interval_time_unit: StringResource by lazy {
      StringResource("string:interval_time_unit", "interval_time_unit", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 16570, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18334, 50),
      ))
    }

@delegate:ResourceContentHash(-1_671_149_135)
internal val Res.string.ip_is_invalid: StringResource by lazy {
      StringResource("string:ip_is_invalid", "ip_is_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 16646, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18414, 41),
      ))
    }

@delegate:ResourceContentHash(533_289_457)
internal val Res.string.its_in_beta_test: StringResource by lazy {
      StringResource("string:its_in_beta_test", "its_in_beta_test", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 16688, 172),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18456, 216),
      ))
    }

@delegate:ResourceContentHash(-513_747_440)
internal val Res.string.la_ar: StringResource by lazy {
      StringResource("string:la_ar", "la_ar", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18673, 33),
      ))
    }

@delegate:ResourceContentHash(-1_444_816_079)
internal val Res.string.la_az: StringResource by lazy {
      StringResource("string:la_az", "la_az", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18707, 33),
      ))
    }

@delegate:ResourceContentHash(65_154_890)
internal val Res.string.la_be: StringResource by lazy {
      StringResource("string:la_be", "la_be", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18741, 41),
      ))
    }

@delegate:ResourceContentHash(1_879_872_125)
internal val Res.string.la_da: StringResource by lazy {
      StringResource("string:la_da", "la_da", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18783, 21),
      ))
    }

@delegate:ResourceContentHash(871_156_848)
internal val Res.string.la_de: StringResource by lazy {
      StringResource("string:la_de", "la_de", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18805, 25),
      ))
    }

@delegate:ResourceContentHash(-2_005_328_783)
internal val Res.string.la_en_US: StringResource by lazy {
      StringResource("string:la_en_US", "la_en_US", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18831, 28),
      ))
    }

@delegate:ResourceContentHash(530_396_056)
internal val Res.string.la_es: StringResource by lazy {
      StringResource("string:la_es", "la_es", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18860, 25),
      ))
    }

@delegate:ResourceContentHash(-2_131_162_797)
internal val Res.string.la_fa: StringResource by lazy {
      StringResource("string:la_fa", "la_fa", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18886, 29),
      ))
    }

@delegate:ResourceContentHash(-2_005_968_905)
internal val Res.string.la_fil: StringResource by lazy {
      StringResource("string:la_fil", "la_fil", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18916, 26),
      ))
    }

@delegate:ResourceContentHash(1_591_351_798)
internal val Res.string.la_fr: StringResource by lazy {
      StringResource("string:la_fr", "la_fr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18943, 25),
      ))
    }

@delegate:ResourceContentHash(-1_915_655_632)
internal val Res.string.la_hu: StringResource by lazy {
      StringResource("string:la_hu", "la_hu", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18969, 21),
      ))
    }

@delegate:ResourceContentHash(500_923_276)
internal val Res.string.la_in: StringResource by lazy {
      StringResource("string:la_in", "la_in", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18991, 25),
      ))
    }

@delegate:ResourceContentHash(1_456_086_252)
internal val Res.string.la_it: StringResource by lazy {
      StringResource("string:la_it", "la_it", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19017, 25),
      ))
    }

@delegate:ResourceContentHash(619_627_296)
internal val Res.string.la_ja: StringResource by lazy {
      StringResource("string:la_ja", "la_ja", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19043, 25),
      ))
    }

@delegate:ResourceContentHash(1_844_838_090)
internal val Res.string.la_ko: StringResource by lazy {
      StringResource("string:la_ko", "la_ko", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19069, 25),
      ))
    }

@delegate:ResourceContentHash(-1_453_327_036)
internal val Res.string.la_ms: StringResource by lazy {
      StringResource("string:la_ms", "la_ms", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19095, 21),
      ))
    }

@delegate:ResourceContentHash(1_789_055_965)
internal val Res.string.la_nl: StringResource by lazy {
      StringResource("string:la_nl", "la_nl", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19117, 29),
      ))
    }

@delegate:ResourceContentHash(-1_855_657_385)
internal val Res.string.la_pl: StringResource by lazy {
      StringResource("string:la_pl", "la_pl", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19147, 21),
      ))
    }

@delegate:ResourceContentHash(1_228_670_545)
internal val Res.string.la_pt_BR: StringResource by lazy {
      StringResource("string:la_pt_BR", "la_pt_BR", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19169, 44),
      ))
    }

@delegate:ResourceContentHash(1_558_605_286)
internal val Res.string.la_ru: StringResource by lazy {
      StringResource("string:la_ru", "la_ru", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19214, 33),
      ))
    }

@delegate:ResourceContentHash(-2_034_774_950)
internal val Res.string.la_sr: StringResource by lazy {
      StringResource("string:la_sr", "la_sr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19248, 29),
      ))
    }

@delegate:ResourceContentHash(-1_350_377_726)
internal val Res.string.la_tr: StringResource by lazy {
      StringResource("string:la_tr", "la_tr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19278, 25),
      ))
    }

@delegate:ResourceContentHash(-1_843_455_420)
internal val Res.string.la_uk: StringResource by lazy {
      StringResource("string:la_uk", "la_uk", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19304, 41),
      ))
    }

@delegate:ResourceContentHash(-1_472_715_421)
internal val Res.string.la_vi: StringResource by lazy {
      StringResource("string:la_vi", "la_vi", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19346, 33),
      ))
    }

@delegate:ResourceContentHash(-207_453_495)
internal val Res.string.la_zh_CN: StringResource by lazy {
      StringResource("string:la_zh_CN", "la_zh_CN", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19380, 32),
      ))
    }

@delegate:ResourceContentHash(-2_070_372_858)
internal val Res.string.la_zh_TW: StringResource by lazy {
      StringResource("string:la_zh_TW", "la_zh_TW", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19413, 32),
      ))
    }

@delegate:ResourceContentHash(1_776_378_114)
internal val Res.string.language: StringResource by lazy {
      StringResource("string:language", "language", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 16926, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19523, 28),
      ))
    }

@delegate:ResourceContentHash(-549_378_030)
internal val Res.string.language_of_film_content: StringResource by lazy {
      StringResource("string:language_of_film_content", "language_of_film_content", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 16861, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19446, 76),
      ))
    }

@delegate:ResourceContentHash(1_125_870_047)
internal val Res.string.large: StringResource by lazy {
      StringResource("string:large", "large", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 16951, 17),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19552, 21),
      ))
    }

@delegate:ResourceContentHash(1_989_045_808)
internal val Res.string.leave_blank_is_default_branch: StringResource by lazy {
      StringResource("string:leave_blank_is_default_branch", "leave_blank_is_default_branch", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 16969, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19574, 81),
      ))
    }

@delegate:ResourceContentHash(806_582_610)
internal val Res.string.link: StringResource by lazy {
      StringResource("string:link", "link", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17071, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19684, 20),
      ))
    }

@delegate:ResourceContentHash(286_475_875)
internal val Res.string.link_to: StringResource by lazy {
      StringResource("string:link_to", "link_to", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17043, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19656, 27),
      ))
    }

@delegate:ResourceContentHash(-1_679_602_536)
internal val Res.string.loading: StringResource by lazy {
      StringResource("string:loading", "loading", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17092, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19705, 31),
      ))
    }

@delegate:ResourceContentHash(-228_197_538)
internal val Res.string.local_network_cast: StringResource by lazy {
      StringResource("string:local_network_cast", "local_network_cast", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 17124, 46),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("display_style_square", Res.string.display_style_square)
  map.put("display_style_waterfall", Res.string.display_style_waterfall)
  map.put("donate", Res.string.donate)
  map.put("donation_open_failed", Res.string.donation_open_failed)
  map.put("donation_qr_description", Res.string.donation_qr_description)
  map.put("donation_scan_hint", Res.string.donation_scan_hint)
  map.put("downloading_update", Res.string.downloading_update)
  map.put("dream_description", Res.string.dream_description)
  map.put("dream_label", Res.string.dream_label)
  map.put("duo_fold_effect", Res.string.duo_fold_effect)
  map.put("duo_fold_retreat", Res.string.duo_fold_retreat)
  map.put("edit", Res.string.edit)
  map.put("email", Res.string.email)
  map.put("empty_content", Res.string.empty_content)
  map.put("enable_ai_image_summary", Res.string.enable_ai_image_summary)
  map.put("error", Res.string.error)
  map.put("fading", Res.string.fading)
  map.put("fast", Res.string.fast)
  map.put("featured_collections_photos", Res.string.featured_collections_photos)
  map.put("feedback", Res.string.feedback)
  map.put("flip_demo_back_to_front", Res.string.flip_demo_back_to_front)
  map.put("flip_demo_front_to_back", Res.string.flip_demo_front_to_back)
  map.put("flip_demo_horizontal_title", Res.string.flip_demo_horizontal_title)
  map.put("flip_demo_vertical_title", Res.string.flip_demo_vertical_title)
  map.put("flip_effect", Res.string.flip_effect)
  map.put("focus_scale", Res.string.focus_scale)
  map.put("follow_system", Res.string.follow_system)
  map.put("forward", Res.string.forward)
  map.put("frame_style", Res.string.frame_style)
  map.put("frame_wall_fix_size", Res.string.frame_wall_fix_size)
  map.put("frame_wall_random_size", Res.string.frame_wall_random_size)
  map.put("gallery_add_photos", Res.string.gallery_add_photos)
  map.put("gallery_limited_selection_hint", Res.string.gallery_limited_selection_hint)
  map.put("gallery_no_new_photos", Res.string.gallery_no_new_photos)
  map.put("gallery_no_photos", Res.string.gallery_no_photos)
  map.put("gallery_remove_selected_confirm", Res.string.gallery_remove_selected_confirm)
  map.put("gallery_select_more_photos", Res.string.gallery_select_more_photos)
  map.put("gallery_selected_count", Res.string.gallery_selected_count)
  map.put("gallery_selected_photos", Res.string.gallery_selected_photos)
  map.put("gallery_selection_access_required", Res.string.gallery_selection_access_required)
  map.put("gallery_source_name", Res.string.gallery_source_name)
  map.put("gallery_source_not_found", Res.string.gallery_source_not_found)
  map.put("gallery_updated", Res.string.gallery_updated)
  map.put("get_token", Res.string.get_token)
  map.put("gitee_access_token_tips_title", Res.string.gitee_access_token_tips_title)
  map.put("gitee_acess_token_tips_1", Res.string.gitee_acess_token_tips_1)
  map.put("gitee_acess_token_tips_2", Res.string.gitee_acess_token_tips_2)
  map.put("gitee_acess_token_tips_3", Res.string.gitee_acess_token_tips_3)
  map.put("gitee_acess_token_tips_4", Res.string.gitee_acess_token_tips_4)
  map.put("gitee_acess_token_tips_5", Res.string.gitee_acess_token_tips_5)
  map.put("github_access_token_tips_1", Res.string.github_access_token_tips_1)
  map.put("github_access_token_tips_2", Res.string.github_access_token_tips_2)
  map.put("github_access_token_tips_3", Res.string.github_access_token_tips_3)
  map.put("github_access_token_tips_4", Res.string.github_access_token_tips_4)
  map.put("github_access_token_tips_5", Res.string.github_access_token_tips_5)
  map.put("github_access_token_tips_title", Res.string.github_access_token_tips_title)
  map.put("have_no_permission", Res.string.have_no_permission)
  map.put("help", Res.string.help)
  map.put("hide_password", Res.string.hide_password)
  map.put("home", Res.string.home)
  map.put("host", Res.string.host)
  map.put("host_is_invalid", Res.string.host_is_invalid)
  map.put("interval", Res.string.interval)
  map.put("interval_time_unit", Res.string.interval_time_unit)
  map.put("ip_is_invalid", Res.string.ip_is_invalid)
  map.put("its_in_beta_test", Res.string.its_in_beta_test)
  map.put("la_ar", Res.string.la_ar)
  map.put("la_az", Res.string.la_az)
  map.put("la_be", Res.string.la_be)
  map.put("la_da", Res.string.la_da)
  map.put("la_de", Res.string.la_de)
  map.put("la_en_US", Res.string.la_en_US)
  map.put("la_es", Res.string.la_es)
  map.put("la_fa", Res.string.la_fa)
  map.put("la_fil", Res.string.la_fil)
  map.put("la_fr", Res.string.la_fr)
  map.put("la_hu", Res.string.la_hu)
  map.put("la_in", Res.string.la_in)
  map.put("la_it", Res.string.la_it)
  map.put("la_ja", Res.string.la_ja)
  map.put("la_ko", Res.string.la_ko)
  map.put("la_ms", Res.string.la_ms)
  map.put("la_nl", Res.string.la_nl)
  map.put("la_pl", Res.string.la_pl)
  map.put("la_pt_BR", Res.string.la_pt_BR)
  map.put("la_ru", Res.string.la_ru)
  map.put("la_sr", Res.string.la_sr)
  map.put("la_tr", Res.string.la_tr)
  map.put("la_uk", Res.string.la_uk)
  map.put("la_vi", Res.string.la_vi)
  map.put("la_zh_CN", Res.string.la_zh_CN)
  map.put("la_zh_TW", Res.string.la_zh_TW)
  map.put("language", Res.string.language)
  map.put("language_of_film_content", Res.string.language_of_film_content)
  map.put("large", Res.string.large)
  map.put("leave_blank_is_default_branch", Res.string.leave_blank_is_default_branch)
  map.put("link", Res.string.link)
  map.put("link_to", Res.string.link_to)
  map.put("loading", Res.string.loading)
  map.put("local_network_cast", Res.string.local_network_cast)
}
